import React from "react"
import FieldProto_FormElement from "../../../proto/render/form-element"

import Ui5MultiselectOptions from "../../../../gd-ui/multiselect-options/ui5-multiselect-options"

export default class FieldMultiselectCheckbox_FormElement extends FieldProto_FormElement {

    render() {
        const classes: string = Classes("ui5-txt-default h-36 p-l-10 p-r-10 border-box", this.props.className)

        return <Ui5MultiselectOptions className         = {classes}
                                      form              = {this.props.form}
                                      name              = {this.props.field.fieldId}
                                      typeFilterValues  = {this.props.field.options || []}
                                      lockedValues      = {this.props.field.lockedValues || []}/>
    }
}